import React from 'react';
import { Typography } from '@mui/material';

import { GetAPIURL, GenerateURI, GenerateJSON } from '../Common/query';

export default class WordCount extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      uri: "loading...",
      wordCount: "loading...",
    };
  }

  async getWordCount() {
    const json = GenerateJSON(this.props.value);
    const uri = GenerateURI(this.props.value);
    const URL = GetAPIURL() + "/word-count/" + this.props.value.wordLength;

    console.log("url = " + URL);
    const request = {
      "word-count": this.props.value.wordLength,
      "match": json.matches,
      "partial": json.partials,
      "missing": json.misses
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(request)
    };
    const response = await fetch(URL, requestOptions);
    const data = await response.json();
    this.setState({
      uri: uri,
      wordCount: data.count.toLocaleString("en-US"),
    });
  }

  render() {
    const uri = GenerateURI(this.props.value);
    if (uri !== this.state.uri) {
      this.getWordCount();
    }

    return (
      <Typography variant="body1">{this.state.wordCount}</Typography>
    );
  }
}

